<mat-toolbar class="mb-4">Skapa ny användare</mat-toolbar>

<form [formGroup]="createUserForm" class="margin-20" (ngSubmit)="createNewUser()">

  <mat-form-field appearance="outline">
    <mat-label>Språk</mat-label>
    <mat-select formControlName="language">
      <mat-option value="Svenska">
        Svenska
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Förnamn</mat-label>
    <input matInput placeholder="Namn" formControlName="firstname">
    <mat-icon matSuffix>person</mat-icon>
    @if (createUserForm.controls.firstname.errors) {
    <mat-error>Skriv in förnamn</mat-error>
    }
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Efternamn</mat-label>
    <input matInput placeholder="Namn" formControlName="lastname">
    <mat-icon matSuffix>person</mat-icon>
    @if (createUserForm.controls.lastname.errors) {
    <mat-error>Skriv in efternamn</mat-error>
    }
  </mat-form-field>

  <mat-form-field appearance="outline">
    <mat-label>Email</mat-label>
    <input matInput placeholder="Email" formControlName="email" [errorStateMatcher]="matcher">
    <mat-icon matSuffix>email</mat-icon>
    @if (createUserForm.controls.email.errors) {
    <mat-error>Skriv in mailadress</mat-error>
    }
  </mat-form-field>

  <div class="d-flex justify-content-between">
    <button mat-raised-button color="warn" type="button" (click)="cancelForm()">
      AVBRYT
    </button>
    <button mat-raised-button color="primary" type="submit" [disabled]="!createUserForm.valid">
      SKAPA ANVÄNDARE
    </button>
  </div>

</form>